import { Directive, HostListener, Input, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[Mascara]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MascaraDirective,
    multi: true
  }]
})
export class MascaraDirective implements ControlValueAccessor {

  onTouched: any;
  onChange: any;

  @Input('Mascara') Mascara: string;

  constructor(private el: ElementRef, private _changeDetect: ChangeDetectorRef) {}

  writeValue(value: any): void {
    if (value) {
      this.el.nativeElement.value = this.aplicarMascara(value);
    }
    else {
      this.el.nativeElement.value = "";
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this._changeDetect.detectChanges();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    const valor = $event.target.value;
    const valorComMascara = this.aplicarMascara(valor);

    $event.target.value = valorComMascara;
    this.onChange(valorComMascara);

  }

  @HostListener('blur', ['$event'])
  onBlur($event: any) {
    if ($event.target.value.length === this.Mascara.length) {
      return;
    }
    else
      $event.target.value = this.aplicarMascara($event.target.value);

    this.onChange($event.target.value);
    if ($event.target.value.length === this.Mascara.length) {
      return;
    }
  }

  aplicarMascara(valor: string): string {
    if(this.Mascara === '99.999.999/9999-99') {
      return this.cnpjMaskHandler(valor);
    }

    return this.generalMaskHandler(valor);
  }

  cnpjMaskHandler(valor: string): string {
    const clean = valor.toUpperCase().replace(/[^A-Z0-9]/g,'')
    const firstPart = clean.slice(0, 12)
    const lastPart = clean.slice(12).replace(/[^0-9]/g,'').slice(0, 2)
    const combined = firstPart + lastPart

    return combined
      .replace(/([A-Z0-9]{2})([A-Z0-9])/,'$1.$2')
      .replace(/([A-Z0-9]{3})([A-Z0-9])/,'$1.$2')
      .replace(/([A-Z0-9]{3})([A-Z0-9]{1,2})/,'$1/$2')
      .replace(/([A-Z0-9]{4})(\d{1,2})/,'$1-$2')
      .replace(/(-\d{2})\d+$/,'$1')
  }

  generalMaskHandler(valor: string): string {
    valor = valor.replace(/\D/g, '');
    let pad = this.Mascara.replace(/\D/g, '').replace(/9/g, '_');
    let valorMask = valor + pad.substring(0, pad.length - valor.length);
    let valorMaskPos = 0;

    //---- se for telefone, verifica 9º dígito ----
    var aux = valorMask.replace('_', '');
    if ((aux.length == 10) && (this.Mascara == "(99) 99999-9999")) {
      this.Mascara = "(99) 9999-9999";
    }
    else {
      if ((aux.length == 11) && (this.Mascara == "(99) 9999-9999")) {
        this.Mascara = "(99) 99999-9999";
      }
    }
    //------------------------------------------

    valor = '';
    for (let i = 0; i < this.Mascara.length; i++) {
      if (isNaN(parseInt(this.Mascara.charAt(i)))) {
        valor += this.Mascara.charAt(i);
      } else {
        valor += valorMask[valorMaskPos++];
      }
    }

    if (valor.indexOf('_') > -1) {
      valor = valor.substr(0, valor.indexOf('_'));
    }

    return valor;
  }
}
